import React from 'react';
import { Typography, Box } from '@mui/material';
import { CenteredFlexBox } from '../../../Components/FlexBox';
import IconButton from '../../../Components/Button/IconButton';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import capitalize from '../../../Helpers/StringsFormatting/capitalize';

const KanbanGroupHeader = function KanbanGroupHeader({
  title,
  count,
  color,
  advancementThreshold,
  lowerThreshold,
  description,
  isFirst,
  isLast,
}) {
  return (
    <Box sx={{
      padding: "4px"
    }}>
      <CenteredFlexBox
        gap="8px"
        padding="8px"
        sx={{ backgroundColor: color, borderRadius: '50px' }}
      >
        <CenteredFlexBox
          justifyContent="center"
          sx={{
            backgroundColor: '#fff',
            minWidth: '50px',
            borderRadius: '50px',
          }}
        >
          <Typography color={color} variant="h6">
            {count}
          </Typography>
        </CenteredFlexBox>
        <CenteredFlexBox gap="6px">
          <Typography
            variant="h6"
            noWrap
            sx={{
              fontSize: "18px",
              color: "#fff"
            }}>
            {capitalize(title)}
          </Typography>
          {description && (
            <IconButton
              id="stage-description-help"
              size="small"
              title={description}
              tooltipProps={{
                placement: 'top',
                arrow: true,
                componentsProps: {
                  tooltip: {
                    sx: {
                      padding: '8px',
                      fontSize: '1.2rem',
                    },
                  },
                },
              }}
            >
              <HelpOutlineRoundedIcon sx={{ color: '#fff' }} />
            </IconButton>
          )}
        </CenteredFlexBox>
        <CenteredFlexBox
          marginLeft="auto"
          justifyContent="center"
          sx={{
            backgroundColor: 'rgba(180, 180, 180, 0.3)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            minWidth: '60px',
            borderRadius: '50px',
            padding: '4px',
          }}
        >
          <Typography variant="subtitle1" sx={{
            color: "#fff"
          }}>
            {isFirst
              ? '0%'
              : isLast
                ? '100%'
                : `${lowerThreshold}% - ${advancementThreshold}%`}
          </Typography>
        </CenteredFlexBox>
      </CenteredFlexBox>
    </Box>
  );
};

export default KanbanGroupHeader;
